import { Alert } from "@mui/material";

export function Error({children, show}){

    return show !== false && 
        <Alert severity='error'>{children}</Alert>
}

export function Success({children, show}){

    return show !== false && 
        <Alert severity='success'>{children}</Alert>
}

export function Warning({children, show}){

    return show !== false && 
        <Alert severity='warning'>{children}</Alert>
}

export default function Info({children, show}){

    return show !== false && 
        <Alert severity='info'>{children}</Alert>
}